import { render } from "./sortable-column.vue?vue&type=template&id=e4e901aa&ts=true"
import script from "./sortable-column.vue?vue&type=script&lang=ts"
export * from "./sortable-column.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__